import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import { ACCESS_LEVEL_STR } from 'pages/User/AccessLevel';
import { GIFT_GOLD_STAR_NOTIFICATION_EXTRA } from 'enum/helpers';
import { chatFontSettings } from 'utils/helpers';

import styles from './ChatNotificationsTypes.css';


function GiftMobileNotification({ message, isDesktop, chatSettings }) {
  const { profileName } = ProfileStore;

  const handleTranslate = () => {
    let sender = message.senderOriginalUsername;
    if (message.senderAccessLevel === ACCESS_LEVEL_STR.GUEST) {
      sender = translate('v2profile.gift.sender.guest');
    } else if (message.anonymous === '1' || message.anonymous === true) {
      sender = translate('tipping.an.anonymous.user');
    }

    if (message.notificationExtra === GIFT_GOLD_STAR_NOTIFICATION_EXTRA) {
      return translate('v2profile.gift.notification.gold', {
        0: `<b>${sender}</b>`,
        1: `<b>${profileName}</b>`,
        2: `<span class=${styles.goldStarNotif}>`,
        3: '</span>',
      });
    }
    if (isDesktop) {
      return translate('v2profile.gift.sent.notification', {
        0: `<span class=${styles.giftNotificationDesktop}><strong>${sender}</strong>`,
        1: `(<strong>${message.giftValue}</strong>`,
        2: `<strong>${translate('v2profile.tipping.token.plural')}</strong>)`,
      });
    }

    return translate('v2profile.gift.sent.notification', {
      0: `<span class=${styles.giftNotificationMobile}>${sender}</span>`,
      1: `<span class=${styles.yellowText}><strong>${message.giftValue}</strong>`,
      2: `<strong>${translate('v2profile.tipping.token.plural')}</strong>`,
    });


  };

  return (
    <div className={isDesktop ? styles.giftDesktopWrapper : styles.notifWrapper}>
      <img
        alt="gift"
        className={isDesktop ? styles.giftDesktopImg : styles.notifImg}
        src={message.giftImage}
      />
      <span
        className={isDesktop ? styles.giftNotifText : styles.basicNotifText}
        style={chatFontSettings(isDesktop, chatSettings)}
      >
        {handleTranslate()}
      </span>
    </div>
  );
}

GiftMobileNotification.propTypes = {
  chatSettings: PropTypes.object,
  isDesktop: PropTypes.bool,
  message: PropTypes.object,
};

GiftMobileNotification.defaultProps = {
  chatSettings: undefined,
  isDesktop: undefined,
  message: undefined,
};

export default GiftMobileNotification;
